
export const getRecipients = (state) => {
  try {
    const recipients = state.recipients?.[state.closeAlarmModal.deviceId];
    return recipients || [];
  } catch (e) {
    return [];
  }
};
